//@ts-nocheck
import RouteCls from "./lib/route/route";
import Router from "./routes/router";
import { Helmet } from "react-helmet";
import Atom from "./components/atom/index";
import { Redirect } from "./components/router";
import Services from "./lib/services/services";
import Appbar from "./components/Appbar/appbar";
import { Routes, Route } from "react-router";
import Content from "./components/Content/Content";
import SwController from "./components/swController";
import { useLocation } from "./hooks/router/useLocation";
import ARCPosition from "./components/ARCPosition/ARCPosition";
import MessageController from "./components/message/messageController";
import React, {
  useEffect,
  useState,
  Suspense,
  useLayoutEffect,
  useCallback,
} from "react";
import { useOpener } from "./hooks/opener/useOpener";
import { Modal } from "./components/baseElement";
import { convertRouteToCls } from "./lib/utils";

const location = window.location;

const _templateBoxModified = JSON.parse(JSON.stringify(_template_box));
const _templateBoxModified1 = JSON.parse(JSON.stringify(_template_box));
const _templateBoxModifiedUp = JSON.parse(JSON.stringify(_template_box));
const _templateBoxModifiedDown = JSON.parse(JSON.stringify(_template_box));

function App() {
  const [data, setData] = useState<any>();
  const [convert, setConvertUrl] = useState<string>();
  const [menu, setMenu] = useState<any>({
    frag: {},
    modal: {},
    itemProps: {},
    menuElement: [],
    appbarMenu: [],
  });
  const [update, setUpdate] = useState<boolean>(false);
  const [message, setMessage] = useState({ action: "", data: "" });

  const { isOpen, onOpen, onClose } = useOpener({});

  const currentLocation = useLocation();

  useEffect(() => {
    // const permission = Storage.getPermission();
    // if (!permission?.pushMessage) {
    //   setSwState("pushMessage");
    // }
    stopHtmlLottie();

    /*   if (__function) {
          for (let i in __function) {
            eval(__function[i]);
          }
        }*/

    
  }, []);

  useEffect(() => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        setMessage(event.data);
      });
    }
  });

  useLayoutEffect(() => {
    void fetchBoxElement();

    function updateSize() {
      const r = document.querySelector(":root");
      r.style.setProperty("--vh", `${document.documentElement.clientHeight}px`);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    if (
      (location?.pathname === "/" &&
        location?.search?.includes("?CID_READY")) ||
      location.pathname.includes("/ARC/home/home")
    ) {
      let newRouter = RouteCls.removeQueryParam(
        window.location.href,
        "CID_READY"
      );
      newRouter = RouteCls.removeQueryParam(newRouter, "VERSION");
      const [, search] = newRouter.split("?");

      const newUrl = search ? `/?${search}` : "/";
      setConvertUrl(newUrl);
    }

    const cls = convertRouteToCls(location?.pathname);
    document.body.setAttribute("data-class", cls);

    return () => {
      document.body.removeAttribute("data-class");
    };

    
  }, [location]);

  useEffect(() => {
    
  }, [currentLocation]);

  useEffect(() => {
    setUpdate(!update);
    
  }, [location.pathname]);

  useEffect(() => {
    if (menu?.modal && Object.keys(menu?.modal).length) {
      const modalConfig = menu?.itemProps?.modal;
      const shownSessionCount = modalConfig?.shownSessionCount || 1;
      // const modalPos = window.sessionStorage.getItem("modalPosition");
      let count = window.sessionStorage.getItem("modalPositionCount") || 1;
      if (count <= shownSessionCount) {
        onOpen();
        window.sessionStorage.setItem("modalPosition", "set");
        count++;
        window.sessionStorage.setItem("modalPositionCount", count);
      }
    }
    
  }, [menu]);

  async function fetchBoxElement() {
    const result = await Services.Req({
      data: { app: "element", view: "boxElement" },
      noCache: true,
    });
    const data = {};
    if (!result.error) {
      const cloneTemplate = JSON.parse(JSON.stringify(_template_box));
      const cloneTemplate2 = JSON.parse(JSON.stringify(_template_box));

      let itemProps = {};
      const menuElement = [];
      const appbarMenu = {};
      const frag = {};
      const modal = {};
      const { elementList: down, itemProps: downProps } = findBoxElement({
        itemProps,
        result,
        name: "§DOWN",
      });
      const { elementList: up, itemProps: upProps } = findBoxElement({
        itemProps,
        result,
        name: "§UP",
      });

      itemProps = { ...itemProps, ...downProps };
      itemProps = { ...itemProps, ...upProps };

      const templateBoxAppbar =
        _template_box?.properties?.PAGE?.properties["§APP_BAR"]?.properties;

      const templateBoxFrag =
        cloneTemplate?.properties?.PAGE?.properties["§FRAG"]?.properties;

      const templateBoxModal =
        cloneTemplate2?.properties?.PAGE?.properties["§MODAL"]?.properties;

      /*      const templateBoxUp =
              cloneTemplate2?.properties?.PAGE?.properties["§UP"]?.properties;

            const templateBoxDown =
              cloneTemplate2?.properties?.PAGE?.properties["§DOWN"]?.properties;*/

      for (let i in result.list) {
        if (result.list[i].element === "menu") {
          result.list[i].menu = result?.data[result.list[i].ID]?.menu;
        }
      }
      if (templateBoxAppbar) {
        for (let i in templateBoxAppbar) {
          for (let j in result.list) {
            if (result.list[j]?.position.includes(i)) {
              appbarMenu[j] = result.list[j];
            }
          }
        }
      }

      if (templateBoxFrag) {
        for (let i in templateBoxFrag) {
          for (let j in result.list) {
            if (result.list[j]?.position.includes(i)) {
              frag[j] = result.list[j];
            }
          }
        }
      }

      if (templateBoxModal) {
        for (let i in templateBoxModal) {
          for (let j in result.list) {
            if (result.list[j]?.position.includes(i)) {
              modal[j] = result.list[j];
            }
          }
          if (templateBoxModal[i].config) {
            itemProps[i] = templateBoxModal[i].config;
          }
        }
      }
      /*     if (templateBoxUp) {
              for (let i in templateBoxUp) {
                for (let j in result.list) {
                  if (result.list[j]?.position.includes(i)) {
                    up[j] = result.list[j];
                  }
                }
                if (templateBoxUp[i].config) {
                  itemProps[i] = templateBoxUp[i].config;
                }
              }
            }
            debugger;
            if (templateBoxDown) {
              for (let i in templateBoxDown) {
                for (let j in result.list) {
                  if (result.list[j]?.position.includes(i)) {
                    down[j] = result.list[j];
                  }
                }
                if (templateBoxDown[i].config) {
                  itemProps[i] = templateBoxDown[i].config;
                }
              }
            }
            console.log(down);*/

      setMenu({ itemProps, menuElement, appbarMenu, frag, modal, up, down });
    }

    setData(data);
  }

  function findBoxElement({ name, itemProps, result }) {
    const cloneTemplate = JSON.parse(JSON.stringify(_template_box));
    const templateBoxElem =
      cloneTemplate?.properties?.PAGE?.properties[name]?.properties;

    const elementList = {};
    if (templateBoxElem) {
      for (let i in templateBoxElem) {
        for (let j in result.list) {
          if (result.list[j]?.position.includes(i)) {
            elementList[j] = result.list[j];
          }
        }
        if (templateBoxElem[i].config) {
          elementList[i] = templateBoxElem[i].config;
        }
      }
    }
    return { elementList, itemProps };
  }

  const MemoizedARCPosition = React.memo(ARCPosition);

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <React.Fragment>
      <div className="App">
        <Helmet>
          <body className={_TemplateConfig?.bodyClass} />
        </Helmet>
        <Appbar
          className={
            location?.pathname === "/"
              ? _TemplateConfig?.frontpage?.appbar?.class || "bg-cprime"
              : _TemplateConfig?.contentpage?.appbar?.class || "bg-cprime"
          }
          style={
            location?.pathname === "/"
              ? _TemplateConfig?.frontpage?.appbar?.style
              : _TemplateConfig?.contentpage?.appbar?.style
          }
        >
          <ARCPosition
            update={update}
            offSynergetic
            data={menu?.appbarMenu}
            elementList={data}
            template={_templateBoxModified?.properties?.PAGE}
          />
        </Appbar>

        <MemoizedARCPosition
          isUp
          update={update}
          offSynergetic
          data={menu?.up}
          elementList={data}
          template={_templateBoxModifiedUp?.properties?.PAGE}
        />

        <Content>
          <Suspense fallback={<div />}>
            <Routes>
              <Route path="*" element={<Router />} />

              {/*  <Route path="/" element={<Home />} />
                            <Route path="/ARC/menu/other/5" element={<OtherMenu />} />*/}
            </Routes>
          </Suspense>
          <MessageController {...message} />

          <MemoizedARCPosition
            isDown
            update={update}
            offSynergetic
            data={menu?.down}
            elementList={data}
            template={_templateBoxModifiedDown?.properties?.PAGE}
          />
        </Content>

        {/*<BoxElementAlert open={isOpen} />*/}
        <Modal open={isOpen} onClose={handleClose} className="boxElementModal">
          <Modal.Body>
            <Atom.Div className="d-flex">
              <Atom.Icon
                className="closeIcon"
                name="times"
                onClick={() => onClose?.()}
              />
            </Atom.Div>
            <ARCPosition
              data={menu?.modal}
              template={_templateBoxModified1?.properties?.PAGE}
              elementList={data}
              {...menu.itemProps}
            />
          </Modal.Body>
        </Modal>

        <MemoizedARCPosition
          data={menu?.frag}
          template={_template_box?.properties?.PAGE}
          // template={_template_box}
          elementList={data}
          {...menu.itemProps}
        />
      </div>

      <SwController state="pushMessage" />

      {convert ? <Redirect to={convert} /> : ""}
    </React.Fragment>
  );
}

export default App;

const stopHtmlLottie = () => {
  // @ts-ignore
  lottie?.stop();
  const elem = document.getElementById("lottie");
  if (elem) {
    // @ts-ignore
    elem.innerHTML = "";
  }
};
